import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import isEmpty from 'lodash/isEmpty';
import get from "lodash/get";
import { produce } from "immer";
import { runtimeUtils } from 'conversional-utils';
import { captureException } from "conversional-exceptions";
import getRenderer from "./renderers";
import { isNode } from "./utils";
import ErrorBoundary from "../components/error/ErrorBoundary";
import ConditionalWrapper from '../components/base/ConditionalWrapper';
var wrapConditional = function (content, component, path) {
    var conditional = get(component, 'Content.show.conditional');
    var conditionalProps = get(component, 'Content.conditionalProps');
    if (isEmpty(conditional) && isEmpty(conditionalProps))
        return content;
    return _jsx(ConditionalWrapper, { conditional: conditional, conditionalProps: conditionalProps, children: content }, path);
};
var resolveDefinitions = function (component) {
    var props = get(component, 'Content.props');
    if (!runtimeUtils.needsResolution(props))
        return component;
    component.Content.props = runtimeUtils.resolveDefinitionsRuntime(props);
    return component;
};
var Node = function (_a) {
    var _b;
    var component = _a.component, path = _a.path, renderWrapper = _a.renderWrapper;
    try {
        if (!isNode(component))
            return null;
        var resolvedComponent = produce(component, resolveDefinitions);
        var renderer = getRenderer((_b = resolvedComponent === null || resolvedComponent === void 0 ? void 0 : resolvedComponent.Content) === null || _b === void 0 ? void 0 : _b.format);
        var content = _jsx(ErrorBoundary, { path: path, children: renderer(resolvedComponent, path) }, path);
        content = wrapConditional(content, component, path);
        if (renderWrapper)
            return renderWrapper(content, path, component);
        return content;
    }
    catch (e) {
        captureException(e, { component: component, path: path });
        return null;
    }
};
export default (Node);
